import { Button } from "@/components/ui/button";

export default function PRMergeConfirmDialog({
  open,
  prReference,
  loading = false,
  onCancel,
  onConfirm,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      onClick={loading ? undefined : onCancel}
      onKeyDown={(event) => {
        if (event.key === "Escape" && !loading) onCancel();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="pr-merge-confirm-title"
        className="glass w-full max-w-md rounded-xl border border-border p-6 space-y-4"
        onClick={(event) => event.stopPropagation()}
        data-testid="pr-merge-confirm-dialog"
      >
        <div>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Confirm action</div>
          <h2 id="pr-merge-confirm-title" className="mt-1 font-display text-xl font-bold">Mark PR as merged</h2>
        </div>
        <p className="text-sm text-muted-foreground">
          Confirm that {prReference || "this pull request"} has been merged.
        </p>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button type="button" onClick={onConfirm} disabled={loading} data-testid="pr-merge-confirm">
            {loading ? "Saving..." : "Confirm"}
          </Button>
        </div>
      </div>
    </div>
  );
}
